import { node } from "~/util/dom";
import { IPoi } from "~/interfaces";
import { CONFIG } from "~/config";

const IMG_SOURCE = `https://api.mapy.${CONFIG.TLD}/poiimg/icon/keyval/`;

export function createKeyValTags(items: IPoi["extend"]["poi"]["keyval_tags"], small?: boolean) {
	const container = node("div");

	container.classList.add("ui-keyvaltags");
	small && container.classList.add("small");

	if (items.length) {
		items.forEach(item => {
			const itemElem = document.createElement("div");
			const icon = new Image();
			const desc = document.createElement("span");

			icon.classList.add("ui-keyvaltags__icon");
			icon.crossOrigin = "anonymous";
			icon.src = `${IMG_SOURCE}${item.icon}.svg`;
			desc.classList.add("ui-keyvaltags__desc");
			desc.textContent = item.text;
			itemElem.classList.add("ui-keyvaltags__item");
			itemElem.append(icon, desc);
			container.append(itemElem);
		});
	}

	return container;
}
